module.exports = __webpack_public_path__ + "img/battle_section1_title.5120795c.png";